import { render, staticRenderFns } from "./qklq.vue?vue&type=template&id=54391437&scoped=true"
import script from "./qklq.vue?vue&type=script&lang=js"
export * from "./qklq.vue?vue&type=script&lang=js"
import style0 from "./qklq.vue?vue&type=style&index=0&id=54391437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54391437",
  null
  
)

export default component.exports